export function noPackstation (value = '') {
  var field_value_lower_case = value.toLowerCase();

  if (field_value_lower_case.indexOf('packstation') !== -1) {
    return false;
  } else {
    return true;
  }
}

export function noPostfiliale (value = '') {
  var field_value_lower_case = value.toLowerCase();

  if (field_value_lower_case.indexOf('postfiliale') !== -1) {
    return false;
  } else {
    return true;
  }
}

export function noStreetNumber (value = '') {
  if (value === '') {
    return false
  }
  var matches = value.match(/\d+/g);
  if (matches != null) {
    return true;
  } else {
    return false
  }
}

export function isNumber (value) {
  if (!value) {
    return true
  }
  if (!isNaN(value)) {
    return true;
  } else {
    return false
  }
}

export function isChecked (value) {

    if (!value) {
        return true
    }
    if (!isNaN(value)) {
        return true;
    } else {
        return false
    }
}

export function isBiggerThanZero (value){
    console.log('isBiggerThanZero',value)
    if (!value) {
        return true
    }
    if (!isNaN(value)) {
        return true;
    } else {

        if (value > 0) {
            return false;
        } else {
            return true
        }
    }
}

export function notEmpty (value) {
  if (value) {

    return true
  }
  return false
}

export function hasNumbers (value) {
  var regex = /\d/g;
  console.log('hasNumbers', value, regex.test(value))

  return regex.test(value);
}

